<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          应急主页
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
export default {
  name: 'ZjEmergencyHome',
  controller: 'UI',
  action: 'Home'
}
</script>
